webpackJsonp([19],{

/***/ 1057:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_faq_vue__ = __webpack_require__(1110);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6120888d_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_faq_vue__ = __webpack_require__(1189);
var normalizeComponent = __webpack_require__(24)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_faq_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6120888d_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_faq_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 1074:
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iaXNvLTg4NTktMSI/Pg0KPCEtLSBHZW5lcmF0b3I6IEFkb2JlIElsbHVzdHJhdG9yIDE4LjEuMSwgU1ZHIEV4cG9ydCBQbHVnLUluIC4gU1ZHIFZlcnNpb246IDYuMDAgQnVpbGQgMCkgIC0tPg0KPHN2ZyB2ZXJzaW9uPSIxLjEiIGlkPSJDYXBhXzEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiIHg9IjBweCIgeT0iMHB4Ig0KCSB2aWV3Qm94PSIwIDAgMjUuOTMgMjUuOTMiIHN0eWxlPSJlbmFibGUtYmFja2dyb3VuZDpuZXcgMCAwIDI1LjkzIDI1LjkzOyIgeG1sOnNwYWNlPSJwcmVzZXJ2ZSI+DQo8Zz4NCgk8ZyBpZD0iYzExOF90cmlhbmdsZSI+DQoJCTxwYXRoIGQ9Ik0yNS4zOTcsNC41NTRoLTIuMDQybC05Ljk3NCwxMi42NDRjLTAuMTAxLDAuMTI0LTAuMjU2LDAuMTk3LTAuNDE2LDAuMTk3Yy0wLjE2NCwwLTAuMzE1LTAuMDczLTAuNDE5LTAuMTk3TDIuNTc1LDQuNTU0DQoJCQlIMC41MzJjLTAuMjA2LDAtMC4zOTIsMC4xMTUtMC40NzksMC4yOTljLTAuMDksMC4xODQtMC4wNjQsMC40MDMsMC4wNiwwLjU2MWwxMi40MzUsMTUuNzYyYzAuMTA0LDAuMTI1LDAuMjU1LDAuMiwwLjQxOSwwLjINCgkJCWMwLjE2LDAsMC4zMTUtMC4wNzUsMC40MTYtMC4yTDI1LjgxNiw1LjQxM2MwLjEyOC0wLjE1NywwLjE0OC0wLjM3NywwLjA1OC0wLjU2MUMyNS43ODksNC42NjksMjUuNjAxLDQuNTU0LDI1LjM5Nyw0LjU1NHoiLz4NCgk8L2c+DQoJPGcgaWQ9IkNhcGFfMV8xODRfIj4NCgk8L2c+DQo8L2c+DQo8Zz4NCjwvZz4NCjxnPg0KPC9nPg0KPGc+DQo8L2c+DQo8Zz4NCjwvZz4NCjxnPg0KPC9nPg0KPGc+DQo8L2c+DQo8Zz4NCjwvZz4NCjxnPg0KPC9nPg0KPGc+DQo8L2c+DQo8Zz4NCjwvZz4NCjxnPg0KPC9nPg0KPGc+DQo8L2c+DQo8Zz4NCjwvZz4NCjxnPg0KPC9nPg0KPGc+DQo8L2c+DQo8L3N2Zz4NCg=="

/***/ }),

/***/ 1075:
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyBhcmlhLWhpZGRlbj0idHJ1ZSIgZm9jdXNhYmxlPSJmYWxzZSIgZGF0YS1wcmVmaXg9ImZhcyIgZGF0YS1pY29uPSJjaGV2cm9uLWxlZnQiIGNsYXNzPSJzdmctaW5saW5lLS1mYSBmYS1jaGV2cm9uLWxlZnQgZmEtdy0xMCIgcm9sZT0iaW1nIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAzMjAgNTEyIj48cGF0aCBmaWxsPSIjZmZmIiBkPSJNMzQuNTIgMjM5LjAzTDIyOC44NyA0NC42OWM5LjM3LTkuMzcgMjQuNTctOS4zNyAzMy45NCAwbDIyLjY3IDIyLjY3YzkuMzYgOS4zNiA5LjM3IDI0LjUyLjA0IDMzLjlMMTMxLjQ5IDI1NmwxNTQuMDIgMTU0Ljc1YzkuMzQgOS4zOCA5LjMyIDI0LjU0LS4wNCAzMy45bC0yMi42NyAyMi42N2MtOS4zNyA5LjM3LTI0LjU3IDkuMzctMzMuOTQgMEwzNC41MiAyNzIuOTdjLTkuMzctOS4zNy05LjM3LTI0LjU3IDAtMzMuOTR6Ij48L3BhdGg+PC9zdmc+"

/***/ }),

/***/ 1110:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(73);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      imageRotate: false,
      is_mobile_app: 1
    };
  },

  watch: {
    "$route.query": {
      handler: function handler(newVal, oldVal) {
        var _this = this;

        console.log({ newVal: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, newVal), oldVal: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, oldVal) });
        var is_mobile_app = parseInt(newVal.is_mobile_app) || 0;

        this.$nextTick(function () {
          if (!!is_mobile_app) {
            _this.is_mobile_app = is_mobile_app;
          }
        });
      },

      immediate: true
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["mapGetters"])(['isRTL']))
});

/***/ }),

/***/ 1189:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.is_mobile_app ? 'wrapper': 'wrapper'},[_c('section',{staticClass:"row back_white mb-3",class:_vm.isRTL ? 'rtl' : ''},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"accordion col-12",attrs:{"role":"tablist"}},[_c('div',{staticClass:"p-1",attrs:{"header-tag":"header","role":"tab"}},[_c('b-button',{directives:[{name:"b-toggle",rawName:"v-b-toggle.accordion-1",modifiers:{"accordion-1":true}}],staticClass:"d-flex text-capitalize btn_acc justify-content-between align-items-center mb-2",attrs:{"block":"","variant":"info"}},[_vm._v("\n        "+_vm._s(_vm.$t("REGISTRATION"))+" \n        "),_c('img',{staticClass:"acc_img",attrs:{"src":__webpack_require__(1075)}})])],1),_vm._v(" "),_c('b-collapse',{staticClass:"mt-3",attrs:{"id":"accordion-1","visible":"","accordion":"my-accordion","role":"tabpanel"}},[_c('div',{staticClass:"col-12 mb-3"},[_c('b-button',{directives:[{name:"b-toggle",rawName:"v-b-toggle.accordion-9",modifiers:{"accordion-9":true}}],staticClass:"d-flex text-capitalize btn_acc_new justify-content-between align-items-center",attrs:{"block":"","variant":"info"}},[_vm._v("\n          "+_vm._s(_vm.$t("H0W_DO_I_REGISTER_WITH_WANASATIME"))+" ?\n          "),_c('img',{staticClass:"acc_img_new",attrs:{"src":__webpack_require__(1074)}})]),_vm._v(" "),_c('b-collapse',{attrs:{"id":"accordion-9","visible":"","accordion":"my-accordion-new","role":"tabpanel"}},[_c('div',{staticClass:"mt-2"},[_c('p',{class:_vm.isRTL ? 'text-right' : ''},[_vm._v(_vm._s(_vm.$t("CLICK_ON_SIGN_UP"))+"."+_vm._s(_vm.$t("ENTER_FULL_NAME"))+". \n                    "+_vm._s(_vm.$t("ONCE_YOU_COMPLETE"))+".")])])])],1),_vm._v(" "),_c('div',{staticClass:"col-12 mb-3"},[_c('b-button',{directives:[{name:"b-toggle",rawName:"v-b-toggle.accordion-10",modifiers:{"accordion-10":true}}],staticClass:"d-flex text-capitalize btn_acc_new justify-content-between align-items-center",attrs:{"block":"","variant":"info"}},[_vm._v("\n           "+_vm._s(_vm.$t("IT_IS_NECESSARY"))+" ?\n          "),_c('img',{staticClass:"acc_img_new",attrs:{"src":__webpack_require__(1074)}})]),_vm._v(" "),_c('b-collapse',{attrs:{"id":"accordion-10","visible":"","accordion":"my-accordion-new","role":"tabpanel"}},[_c('div',{staticClass:"mt-2"},[_c('p',{class:_vm.isRTL ? 'text-right' : ''},[_vm._v(_vm._s(_vm.$t("NO_IT_IS_NOT_NECESSARY")))])])])],1),_vm._v(" "),_c('div',{staticClass:"col-12 mb-3"},[_c('b-button',{directives:[{name:"b-toggle",rawName:"v-b-toggle.accordion-11",modifiers:{"accordion-11":true}}],staticClass:"d-flex text-capitalize btn_acc_new justify-content-between align-items-center",attrs:{"block":"","variant":"info"}},[_vm._v("\n          "+_vm._s(_vm.$t("WHY_AM_I"))+" ?\n          "),_c('img',{staticClass:"acc_img_new",attrs:{"src":__webpack_require__(1074)}})]),_vm._v(" "),_c('b-collapse',{attrs:{"id":"accordion-11","visible":"","accordion":"my-accordion-new","role":"tabpanel"}},[_c('div',{staticClass:"mt-2"},[_c('p',{class:_vm.isRTL ? 'text-right' : ''},[_vm._v(_vm._s(_vm.$t("WE_REQUEST"))+" \n                    "),_c('br'),_vm._v(_vm._s(_vm.$t("TO_ENSURE"))+"."),_c('br'),_vm._v(_vm._s(_vm.$t("TO_NOTIFY"))+". \n                    "),_c('br'),_vm._v(_vm._s(_vm.$t("TO_SEND"))+".")])])])],1),_vm._v(" "),_c('div',{staticClass:"col-12 mb-3"},[_c('b-button',{directives:[{name:"b-toggle",rawName:"v-b-toggle.accordion-12",modifiers:{"accordion-12":true}}],staticClass:"d-flex text-capitalize btn_acc_new justify-content-between align-items-center",attrs:{"block":"","variant":"info"}},[_vm._v("\n          "+_vm._s(_vm.$t("WHAT_ARE_THE_BENEFITS"))+" ?\n          "),_c('img',{staticClass:"acc_img_new",attrs:{"src":__webpack_require__(1074)}})]),_vm._v(" "),_c('b-collapse',{attrs:{"id":"accordion-12","visible":"","accordion":"my-accordion-new","role":"tabpanel"}},[_c('div',{staticClass:"mt-2"},[_c('p',{class:_vm.isRTL ? 'text-right' : ''},[_vm._v(_vm._s(_vm.$t("USER_CAN_OPT")))])])])],1),_vm._v(" "),_c('div',{staticClass:"col-12 mb-3"},[_c('b-button',{directives:[{name:"b-toggle",rawName:"v-b-toggle.accordion-13",modifiers:{"accordion-13":true}}],staticClass:"d-flex text-capitalize btn_acc_new justify-content-between align-items-center",attrs:{"block":"","variant":"info"}},[_vm._v("\n          "+_vm._s(_vm.$t("HOW_DO_I"))+"\n          "),_c('img',{staticClass:"acc_img_new",attrs:{"src":__webpack_require__(1074)}})]),_vm._v(" "),_c('b-collapse',{attrs:{"id":"accordion-13","visible":"","accordion":"my-accordion-new","role":"tabpanel"}},[_c('div',{staticClass:"mt-2"},[_c('p',{class:_vm.isRTL ? 'text-right' : ''},[_vm._v(_vm._s(_vm.$t("USER_CAN_RETRIEVE")))])])])],1)]),_vm._v(" "),_c('div',{staticClass:"p-1",attrs:{"header-tag":"header","role":"tab"}},[_c('b-button',{directives:[{name:"b-toggle",rawName:"v-b-toggle.accordion-2",modifiers:{"accordion-2":true}}],staticClass:"d-flex text-capitalize btn_acc justify-content-between align-items-center mb-2",attrs:{"block":"","variant":"info"}},[_vm._v("\n        "+_vm._s(_vm.$t("TICKET_BOOKING"))+" "),_c('img',{staticClass:"acc_img",attrs:{"src":__webpack_require__(1075)}})])],1),_vm._v(" "),_c('b-collapse',{staticClass:"mt-3",attrs:{"id":"accordion-2","visible":"","accordion":"my-accordion","role":"tabpanel"}},[_c('div',{staticClass:"col-12 mb-3"},[_c('b-button',{directives:[{name:"b-toggle",rawName:"v-b-toggle.accordion-14",modifiers:{"accordion-14":true}}],staticClass:"d-flex text-capitalize btn_acc_new justify-content-between align-items-center",attrs:{"block":"","variant":"info"}},[_vm._v("\n          "+_vm._s(_vm.$t("HOW_DO_I_KNOW"))+" ?\n          "),_c('img',{staticClass:"acc_img_new",attrs:{"src":__webpack_require__(1074)}})]),_vm._v(" "),_c('b-collapse',{attrs:{"id":"accordion-14","visible":"","accordion":"my-accordion-new","role":"tabpanel"}},[_c('div',{staticClass:"mt-2"},[_c('p',{class:_vm.isRTL ? 'text-right' : ''},[_vm._v(_vm._s(_vm.$t("TICKET_BOOKINGS_AUTO")))])])])],1),_vm._v(" "),_c('div',{staticClass:"col-12 mb-3"},[_c('b-button',{directives:[{name:"b-toggle",rawName:"v-b-toggle.accordion-15",modifiers:{"accordion-15":true}}],staticClass:"d-flex text-capitalize btn_acc_new justify-content-between align-items-center",attrs:{"block":"","variant":"info"}},[_vm._v("\n          "+_vm._s(_vm.$t("IS_THERE_A_TELEPHONE_NUMBER"))+" ?\n          "),_c('img',{staticClass:"acc_img_new",attrs:{"src":__webpack_require__(1074)}})]),_vm._v(" "),_c('b-collapse',{attrs:{"id":"accordion-15","visible":"","accordion":"my-accordion-new","role":"tabpanel"}},[_c('div',{staticClass:"mt-2"},[_c('p',{class:_vm.isRTL ? 'text-right' : ''},[_vm._v(_vm._s(_vm.$t("APART_FROM_ONLINE")))]),_vm._v(" "),_c('p',{staticClass:"mt-3",class:_vm.isRTL ? 'text-right' : '',staticStyle:{"color":"red"}},[_vm._v("\n                "+_vm._s(_vm.$t("PLEASE_NOTE")))])])])],1),_vm._v(" "),_c('div',{staticClass:"col-12 mb-3"},[_c('b-button',{directives:[{name:"b-toggle",rawName:"v-b-toggle.accordion-16",modifiers:{"accordion-16":true}}],staticClass:"d-flex text-capitalize btn_acc_new justify-content-between align-items-center",attrs:{"block":"","variant":"info"}},[_vm._v("\n          "+_vm._s(_vm.$t("I_BOOKED_MY_TICKET"))+" ?\n          "),_c('img',{staticClass:"acc_img_new",attrs:{"src":__webpack_require__(1074)}})]),_vm._v(" "),_c('b-collapse',{attrs:{"id":"accordion-16","visible":"","accordion":"my-accordion-new","role":"tabpanel"}},[_c('div',{staticClass:"mt-2"},[_c('p',{class:_vm.isRTL ? 'text-right' : ''},[_vm._v(_vm._s(_vm.$t("IF_YOU_HAVENT"))+" \n                    "),_c('a',{staticStyle:{"color":"#337ab7"},attrs:{"href":"mailto:hello@cineco.com"}},[_vm._v("hello@cineco.com")]),_vm._v(" "+_vm._s(_vm.$t("FOR_ANY")))])])])],1),_vm._v(" "),_c('div',{staticClass:"col-12 mb-3"},[_c('b-button',{directives:[{name:"b-toggle",rawName:"v-b-toggle.accordion-17",modifiers:{"accordion-17":true}}],staticClass:"d-flex text-capitalize btn_acc_new justify-content-between align-items-center",attrs:{"block":"","variant":"info"}},[_vm._v("\n          "+_vm._s(_vm.$t("WHAT_THEATRES_DOES"))+" ?\n          "),_c('img',{staticClass:"acc_img_new",attrs:{"src":__webpack_require__(1074)}})]),_vm._v(" "),_c('b-collapse',{attrs:{"id":"accordion-17","visible":"","accordion":"my-accordion-new","role":"tabpanel"}},[_c('div',{staticClass:"mt-2"},[_c('p',{class:_vm.isRTL ? 'text-right' : ''},[_vm._v("\n                "+_vm._s(_vm.$t("OFFICIAL_TICKETING")))])])])],1)]),_vm._v(" "),_c('div',{staticClass:"p-1",attrs:{"header-tag":"header","role":"tab"}},[_c('b-button',{directives:[{name:"b-toggle",rawName:"v-b-toggle.accordion-3",modifiers:{"accordion-3":true}}],staticClass:"d-flex text-capitalize btn_acc justify-content-between align-items-center mb-2",attrs:{"block":"","variant":"info"}},[_vm._v("\n        "+_vm._s(_vm.$t("MOVIES_STATIC"))),_c('img',{staticClass:"acc_img",attrs:{"src":__webpack_require__(1075)}})])],1),_vm._v(" "),_c('b-collapse',{staticClass:"mt-3",attrs:{"id":"accordion-3","visible":"","accordion":"my-accordion","role":"tabpanel"}},[_c('div',{staticClass:"col-12 mb-3"},[_c('b-button',{directives:[{name:"b-toggle",rawName:"v-b-toggle.accordion-18",modifiers:{"accordion-18":true}}],staticClass:"d-flex text-capitalize btn_acc_new justify-content-between align-items-center",attrs:{"block":"","variant":"info"}},[_vm._v("\n          "+_vm._s(_vm.$t("TICKETS_ON_WANASA"))+" ?\n          "),_c('img',{staticClass:"acc_img_new",attrs:{"src":__webpack_require__(1074)}})]),_vm._v(" "),_c('b-collapse',{attrs:{"id":"accordion-18","visible":"","accordion":"my-accordion-new","role":"tabpanel"}},[_c('div',{staticClass:"mt-2"},[_c('p',{class:_vm.isRTL ? 'text-right' : ''},[_vm._v(_vm._s(_vm.$t("YOU_CAN_BOOK")))])])])],1),_vm._v(" "),_c('div',{staticClass:"col-12 mb-3"},[_c('b-button',{directives:[{name:"b-toggle",rawName:"v-b-toggle.accordion-19",modifiers:{"accordion-19":true}}],staticClass:"d-flex text-capitalize btn_acc_new justify-content-between align-items-center",attrs:{"block":"","variant":"info"}},[_vm._v("\n          "+_vm._s(_vm.$t("HOW_MANY"))+" ?\n          "),_c('img',{staticClass:"acc_img_new",attrs:{"src":__webpack_require__(1074)}})]),_vm._v(" "),_c('b-collapse',{attrs:{"id":"accordion-19","visible":"","accordion":"my-accordion-new","role":"tabpanel"}},[_c('div',{staticClass:"mt-2"},[_c('p',{class:_vm.isRTL ? 'text-right' : ''},[_vm._v(_vm._s(_vm.$t("USER_ARE_ALLOWED"))+" "),_c('a',{staticStyle:{"color":"#337ab7"},attrs:{"href":"mailto:hello@cineco.com"}},[_vm._v("\n                    hello@cineco.com")]),_vm._v(".\n                    ")])])])],1),_vm._v(" "),_c('div',{staticClass:"col-12 mb-3"},[_c('b-button',{directives:[{name:"b-toggle",rawName:"v-b-toggle.accordion-20",modifiers:{"accordion-20":true}}],staticClass:"d-flex text-capitalize btn_acc_new justify-content-between align-items-center",attrs:{"block":"","variant":"info"}},[_vm._v("\n          "+_vm._s(_vm.$t("MIN_AGE"))+" ?\n          "),_c('img',{staticClass:"acc_img_new",attrs:{"src":__webpack_require__(1074)}})]),_vm._v(" "),_c('b-collapse',{attrs:{"id":"accordion-20","visible":"","accordion":"my-accordion-new","role":"tabpanel"}},[_c('div',{staticClass:"mt-2"},[_c('p',{class:_vm.isRTL ? 'text-right' : ''},[_vm._v(_vm._s(_vm.$t("FOR_MOVIE")))])])])],1),_vm._v(" "),_c('div',{staticClass:"col-12 mb-3"},[_c('b-button',{directives:[{name:"b-toggle",rawName:"v-b-toggle.accordion-21",modifiers:{"accordion-21":true}}],staticClass:"d-flex text-capitalize btn_acc_new justify-content-between align-items-center",attrs:{"block":"","variant":"info"}},[_vm._v("\n          "+_vm._s(_vm.$t("WHAT_THEATRES"))+" ?\n          "),_c('img',{staticClass:"acc_img_new",attrs:{"src":__webpack_require__(1074)}})]),_vm._v(" "),_c('b-collapse',{attrs:{"id":"accordion-21","visible":"","accordion":"my-accordion-new","role":"tabpanel"}},[_c('div',{staticClass:"mt-2"},[_c('p',{class:_vm.isRTL ? 'text-right' : ''},[_vm._v(_vm._s(_vm.$t("TICKETING_PARTNER")))])])])],1),_vm._v(" "),_c('div',{staticClass:"col-12 mb-3"},[_c('b-button',{directives:[{name:"b-toggle",rawName:"v-b-toggle.accordion-22",modifiers:{"accordion-22":true}}],staticClass:"d-flex text-capitalize btn_acc_new justify-content-between align-items-center",attrs:{"block":"","variant":"info"}},[_vm._v("\n          "+_vm._s(_vm.$t("SHOWTIME"))+" ?\n          "),_c('img',{staticClass:"acc_img_new",attrs:{"src":__webpack_require__(1074)}})]),_vm._v(" "),_c('b-collapse',{attrs:{"id":"accordion-22","visible":"","accordion":"my-accordion-new","role":"tabpanel"}},[_c('div',{staticClass:"mt-2"},[_c('p',{class:_vm.isRTL ? 'text-right' : ''},[_vm._v(_vm._s(_vm.$t("FIND_SHOWTIME")))])])])],1)]),_vm._v(" "),_c('div',{staticClass:"p-1 d-none",attrs:{"header-tag":"header","role":"tab"}},[_c('b-button',{directives:[{name:"b-toggle",rawName:"v-b-toggle.accordion-4",modifiers:{"accordion-4":true}}],staticClass:"d-flex text-capitalize btn_acc justify-content-between align-items-center mb-2",attrs:{"block":"","variant":"info"}},[_vm._v("\n            "+_vm._s(_vm.$t("EVENTS"))+" "),_c('img',{staticClass:"acc_img",attrs:{"src":__webpack_require__(1075)}})])],1),_vm._v(" "),_c('b-collapse',{staticClass:"mt-3 d-none",attrs:{"id":"accordion-4","visible":"","accordion":"my-accordion","role":"tabpanel"}},[_c('div',{staticClass:"col-12 mb-3"},[_c('b-button',{directives:[{name:"b-toggle",rawName:"v-b-toggle.accordion-23",modifiers:{"accordion-23":true}}],staticClass:"d-flex text-capitalize btn_acc_new justify-content-between align-items-center",attrs:{"block":"","variant":"info"}},[_vm._v("\n          "+_vm._s(_vm.$t("CAN_I"))+" ?\n          "),_c('img',{staticClass:"acc_img_new",attrs:{"src":__webpack_require__(1074)}})]),_vm._v(" "),_c('b-collapse',{attrs:{"id":"accordion-23","visible":"","accordion":"my-accordion-new","role":"tabpanel"}},[_c('div',{staticClass:"mt-2"},[_c('p',{class:_vm.isRTL ? 'text-right' : ''},[_vm._v(_vm._s(_vm.$t("YES_USER")))])])])],1),_vm._v(" "),_c('div',{staticClass:"col-12 mb-3"},[_c('b-button',{directives:[{name:"b-toggle",rawName:"v-b-toggle.accordion-24",modifiers:{"accordion-24":true}}],staticClass:"d-flex text-capitalize btn_acc_new justify-content-between align-items-center",attrs:{"block":"","variant":"info"}},[_vm._v("\n          "+_vm._s(_vm.$t("CAN_I_BOOK"))+" ?\n          "),_c('img',{staticClass:"acc_img_new",attrs:{"src":__webpack_require__(1074)}})]),_vm._v(" "),_c('b-collapse',{attrs:{"id":"accordion-24","visible":"","accordion":"my-accordion-new","role":"tabpanel"}},[_c('div',{staticClass:"mt-2"},[_c('p',{class:_vm.isRTL ? 'text-right' : ''},[_vm._v(_vm._s(_vm.$t("USER_ARE_ALLOWED_A"))+" "),_c('a',{staticStyle:{"color":"#337ab7"},attrs:{"href":"mailto:hello@cineco.com"}},[_vm._v("\n                    hello@cineco.com")]),_vm._v(".\n                    ")])])])],1),_vm._v(" "),_c('div',{staticClass:"col-12 mb-3"},[_c('b-button',{directives:[{name:"b-toggle",rawName:"v-b-toggle.accordion-25",modifiers:{"accordion-25":true}}],staticClass:"d-flex text-capitalize btn_acc_new justify-content-between align-items-center",attrs:{"block":"","variant":"info"}},[_vm._v("\n          "+_vm._s(_vm.$t("IS_THERE"))+" ?\n          "),_c('img',{staticClass:"acc_img_new",attrs:{"src":__webpack_require__(1074)}})]),_vm._v(" "),_c('b-collapse',{attrs:{"id":"accordion-25","visible":"","accordion":"my-accordion-new","role":"tabpanel"}},[_c('div',{staticClass:"mt-2"},[_c('p',{class:_vm.isRTL ? 'text-right' : ''},[_vm._v("\n                        "+_vm._s(_vm.$t("THE_CUT_OFF"))+"\n                ")])])])],1),_vm._v(" "),_c('div',{staticClass:"col-12 mb-3"},[_c('b-button',{directives:[{name:"b-toggle",rawName:"v-b-toggle.accordion-26",modifiers:{"accordion-26":true}}],staticClass:"d-flex text-capitalize btn_acc_new justify-content-between align-items-center",attrs:{"block":"","variant":"info"}},[_vm._v("\n               "+_vm._s(_vm.$t("WHAT_IS_MIN_AGE"))+" ?\n                "),_c('img',{staticClass:"acc_img_new",attrs:{"src":__webpack_require__(1074)}})]),_vm._v(" "),_c('b-collapse',{attrs:{"id":"accordion-26","visible":"","accordion":"my-accordion-new","role":"tabpanel"}},[_c('div',{staticClass:"mt-2"},[_c('p',{class:_vm.isRTL ? 'text-right' : ''},[_vm._v("\n                        "+_vm._s(_vm.$t("AGE_FOR_CHILD"))+"\n                ")])])])],1),_vm._v(" "),_c('div',{staticClass:"col-12 mb-3"},[_c('b-button',{directives:[{name:"b-toggle",rawName:"v-b-toggle.accordion-27",modifiers:{"accordion-27":true}}],staticClass:"d-flex text-capitalize btn_acc_new justify-content-between align-items-center",attrs:{"block":"","variant":"info"}},[_vm._v("\n          "+_vm._s(_vm.$t("HOW_DO_I_ATTEND"))+" ?\n          "),_c('img',{staticClass:"acc_img_new",attrs:{"src":__webpack_require__(1074)}})]),_vm._v(" "),_c('b-collapse',{attrs:{"id":"accordion-27","visible":"","accordion":"my-accordion-new","role":"tabpanel"}},[_c('div',{staticClass:"mt-2"},[_c('p',{class:_vm.isRTL ? 'text-right' : ''},[_vm._v("\n                        "+_vm._s(_vm.$t("YOU_CAN_VISIT"))+"\n                ")])])])],1)]),_vm._v(" "),_c('div',{staticClass:"p-1",attrs:{"header-tag":"header","role":"tab"}},[_c('b-button',{directives:[{name:"b-toggle",rawName:"v-b-toggle.accordion-5",modifiers:{"accordion-5":true}}],staticClass:"d-flex text-capitalize btn_acc justify-content-between align-items-center mb-2",attrs:{"block":"","variant":"info"}},[_vm._v("\n           "+_vm._s(_vm.$t("AFTER_BOOKING"))+" \n            "),_c('img',{staticClass:"acc_img",attrs:{"src":__webpack_require__(1075)}})])],1),_vm._v(" "),_c('b-collapse',{staticClass:"mt-3",attrs:{"id":"accordion-5","visible":"","accordion":"my-accordion","role":"tabpanel"}},[_c('div',{staticClass:"col-12 mb-3"},[_c('b-button',{directives:[{name:"b-toggle",rawName:"v-b-toggle.accordion-28",modifiers:{"accordion-28":true}}],staticClass:"d-flex text-capitalize btn_acc_new justify-content-between align-items-center",attrs:{"block":"","variant":"info"}},[_vm._v("\n          "+_vm._s(_vm.$t("I_BOOKED"))+" ?\n          "),_c('img',{staticClass:"acc_img_new",attrs:{"src":__webpack_require__(1074)}})]),_vm._v(" "),_c('b-collapse',{attrs:{"id":"accordion-28","visible":"","accordion":"my-accordion-new","role":"tabpanel"}},[_c('div',{staticClass:"mt-2"},[_c('p',{class:_vm.isRTL ? 'text-right' : ''},[_vm._v("\n                "+_vm._s(_vm.$t("NO_TICKET")))])])])],1),_vm._v(" "),_c('div',{staticClass:"col-12 mb-3"},[_c('b-button',{directives:[{name:"b-toggle",rawName:"v-b-toggle.accordion-29",modifiers:{"accordion-29":true}}],staticClass:"d-flex text-capitalize btn_acc_new justify-content-between align-items-center",attrs:{"block":"","variant":"info"}},[_vm._v("\n         "+_vm._s(_vm.$t("CAN_I_CHANGE"))+" ?\n          "),_c('img',{staticClass:"acc_img_new",attrs:{"src":__webpack_require__(1074)}})]),_vm._v(" "),_c('b-collapse',{attrs:{"id":"accordion-29","visible":"","accordion":"my-accordion-new","role":"tabpanel"}},[_c('div',{staticClass:"mt-2"},[_c('p',{class:_vm.isRTL ? 'text-right' : ''},[_vm._v(_vm._s(_vm.$t("NO_YOU_CANNOT")))])])])],1),_vm._v(" "),_c('div',{staticClass:"col-12 mb-3"},[_c('b-button',{directives:[{name:"b-toggle",rawName:"v-b-toggle.accordion-30",modifiers:{"accordion-30":true}}],staticClass:"d-flex text-capitalize btn_acc_new justify-content-between align-items-center",attrs:{"block":"","variant":"info"}},[_vm._v("\n          "+_vm._s(_vm.$t("CHANGE_SHOW"))+" ?\n          "),_c('img',{staticClass:"acc_img_new",attrs:{"src":__webpack_require__(1074)}})]),_vm._v(" "),_c('b-collapse',{attrs:{"id":"accordion-30","visible":"","accordion":"my-accordion-new","role":"tabpanel"}},[_c('div',{staticClass:"mt-2"},[_c('p',{class:_vm.isRTL ? 'text-right' : ''},[_vm._v(_vm._s(_vm.$t("ONCE_YOU")))])])])],1),_vm._v(" "),_c('div',{staticClass:"col-12 mb-3"},[_c('b-button',{directives:[{name:"b-toggle",rawName:"v-b-toggle.accordion-31",modifiers:{"accordion-31":true}}],staticClass:"d-flex text-capitalize btn_acc_new justify-content-between align-items-center",attrs:{"block":"","variant":"info"}},[_vm._v("\n          "+_vm._s(_vm.$t("CAN_I_CANCEL"))+" ?\n          "),_c('img',{staticClass:"acc_img_new",attrs:{"src":__webpack_require__(1074)}})]),_vm._v(" "),_c('b-collapse',{attrs:{"id":"accordion-31","visible":"","accordion":"my-accordion-new","role":"tabpanel"}},[_c('div',{staticClass:"mt-2"},[_c('p',{class:_vm.isRTL ? 'text-right' : ''},[_vm._v(_vm._s(_vm.$t("AS_PER_WANASA")))])])])],1),_vm._v(" "),_c('div',{staticClass:"col-12 mb-3"},[_c('b-button',{directives:[{name:"b-toggle",rawName:"v-b-toggle.accordion-32",modifiers:{"accordion-32":true}}],staticClass:"d-flex text-capitalize btn_acc_new justify-content-between align-items-center",attrs:{"block":"","variant":"info"}},[_vm._v("\n          "+_vm._s(_vm.$t("DO_I_NEED"))+" ?\n          "),_c('img',{staticClass:"acc_img_new",attrs:{"src":__webpack_require__(1074)}})]),_vm._v(" "),_c('b-collapse',{attrs:{"id":"accordion-32","visible":"","accordion":"my-accordion-new","role":"tabpanel"}},[_c('div',{staticClass:"mt-2"},[_c('p',{class:_vm.isRTL ? 'text-right' : ''},[_vm._v("\n                "+_vm._s(_vm.$t("CUSTOMER_DO_NOT")))])])])],1)]),_vm._v(" "),_c('div',{staticClass:"p-1",attrs:{"header-tag":"header","role":"tab"}},[_c('b-button',{directives:[{name:"b-toggle",rawName:"v-b-toggle.accordion-6",modifiers:{"accordion-6":true}}],staticClass:"d-flex text-capitalize btn_acc justify-content-between align-items-center mb-2",attrs:{"block":"","variant":"info"}},[_vm._v("\n        "+_vm._s(_vm.$t("PAYMENTS"))+"\n        "),_c('img',{staticClass:"acc_img",attrs:{"src":__webpack_require__(1075)}})])],1),_vm._v(" "),_c('b-collapse',{staticClass:"mt-3",attrs:{"id":"accordion-6","visible":"","accordion":"my-accordion","role":"tabpanel"}},[_c('div',{staticClass:"col-12 mb-3"},[_c('b-button',{directives:[{name:"b-toggle",rawName:"v-b-toggle.accordion-33",modifiers:{"accordion-33":true}}],staticClass:"d-flex text-capitalize btn_acc_new justify-content-between align-items-center",attrs:{"block":"","variant":"info"}},[_vm._v("\n          "+_vm._s(_vm.$t("PAYMENTS_OPTION"))+" ?\n          "),_c('img',{staticClass:"acc_img_new",attrs:{"src":__webpack_require__(1074)}})]),_vm._v(" "),_c('b-collapse',{attrs:{"id":"accordion-33","visible":"","accordion":"my-accordion-new","role":"tabpanel"}},[_c('div',{staticClass:"mt-2"},[_c('p',{class:_vm.isRTL ? 'text-right' : ''},[_vm._v("\n                "+_vm._s(_vm.$t("THREE_PAYMETNS")))]),_vm._v(" "),_c('ul',[_c('li',{class:_vm.isRTL ? 'text-right' : ''},[_vm._v(_vm._s(_vm.$t("DEBIT/CREDIT")))]),_vm._v(" "),_c('li',{class:_vm.isRTL ? 'text-right' : ''},[_vm._v(_vm._s(_vm.$t("PURCHASE_VOUCHER")))]),_vm._v(" "),_c('li',{class:_vm.isRTL ? 'text-right' : ''},[_vm._v(_vm._s(_vm.$t("PAY_DIRECTLY")))])])])])],1),_vm._v(" "),_c('div',{staticClass:"col-12 mb-3"},[_c('b-button',{directives:[{name:"b-toggle",rawName:"v-b-toggle.accordion-34",modifiers:{"accordion-34":true}}],staticClass:"d-flex text-capitalize btn_acc_new justify-content-between align-items-center",attrs:{"block":"","variant":"info"}},[_vm._v("\n                "+_vm._s(_vm.$t("MY_PAYMENT"))+" ?\n          "),_c('img',{staticClass:"acc_img_new",attrs:{"src":__webpack_require__(1074)}})]),_vm._v(" "),_c('b-collapse',{attrs:{"id":"accordion-34","visible":"","accordion":"my-accordion-new","role":"tabpanel"}},[_c('div',{staticClass:"mt-2"},[_c('p',{class:_vm.isRTL ? 'text-right' : ''},[_vm._v("\n                "+_vm._s(_vm.$t("RARE_SITUATION"))+"\n                    ")])])])],1),_vm._v(" "),_c('div',{staticClass:"col-12 mb-3"},[_c('b-button',{directives:[{name:"b-toggle",rawName:"v-b-toggle.accordion-35",modifiers:{"accordion-35":true}}],staticClass:"d-flex text-capitalize btn_acc_new justify-content-between align-items-center",attrs:{"block":"","variant":"info"}},[_vm._v("\n          "+_vm._s(_vm.$t("REFUND_STILL"))+"\n          "),_c('img',{staticClass:"acc_img_new",attrs:{"src":__webpack_require__(1074)}})]),_vm._v(" "),_c('b-collapse',{attrs:{"id":"accordion-35","visible":"","accordion":"my-accordion-new","role":"tabpanel"}},[_c('div',{staticClass:"mt-2"},[_c('p',{class:_vm.isRTL ? 'text-right' : ''},[_vm._v("\n                "+_vm._s(_vm.$t("REVERSE_REQUEST"))+"\n                    ")])])])],1)]),_vm._v(" "),_c('div',{staticClass:"p-1 ",attrs:{"header-tag":"header","role":"tab"}},[_c('b-button',{directives:[{name:"b-toggle",rawName:"v-b-toggle.accordion-7",modifiers:{"accordion-7":true}}],staticClass:"d-flex text-capitalize btn_acc justify-content-between align-items-center mb-2",attrs:{"block":"","variant":"info"}},[_vm._v("\n        "+_vm._s(_vm.$t("VOUCHERS"))+"\n       "),_c('img',{staticClass:"acc_img",attrs:{"src":__webpack_require__(1075)}})])],1),_vm._v(" "),_c('b-collapse',{staticClass:"mt-3",attrs:{"id":"accordion-7","visible":"","accordion":"my-accordion","role":"tabpanel"}},[_c('div',{staticClass:"col-12 mb-3"},[_c('b-button',{directives:[{name:"b-toggle",rawName:"v-b-toggle.accordion-36",modifiers:{"accordion-36":true}}],staticClass:"d-flex text-capitalize btn_acc_new justify-content-between align-items-center",attrs:{"block":"","variant":"info"}},[_vm._v("\n          "+_vm._s(_vm.$t("PAY_FOR"))+" ?\n          "),_c('img',{staticClass:"acc_img_new",attrs:{"src":__webpack_require__(1074)}})]),_vm._v(" "),_c('b-collapse',{attrs:{"id":"accordion-36","visible":"","accordion":"my-accordion-new","role":"tabpanel"}},[_c('div',{staticClass:"mt-2"},[_c('p',{class:_vm.isRTL ? 'text-right' : ''},[_vm._v(_vm._s(_vm.$t("DONT_HAVE_TO")))])])])],1),_vm._v(" "),_c('div',{staticClass:"col-12 mb-3"},[_c('b-button',{directives:[{name:"b-toggle",rawName:"v-b-toggle.accordion-37",modifiers:{"accordion-37":true}}],staticClass:"d-flex text-capitalize btn_acc_new justify-content-between align-items-center",attrs:{"block":"","variant":"info"}},[_vm._v("\n          "+_vm._s(_vm.$t("HOW_LONG"))+" ?\n          "),_c('img',{staticClass:"acc_img_new",attrs:{"src":__webpack_require__(1074)}})]),_vm._v(" "),_c('b-collapse',{attrs:{"id":"accordion-37","visible":"","accordion":"my-accordion-new","role":"tabpanel"}},[_c('div',{staticClass:"mt-2"},[_c('p',{class:_vm.isRTL ? 'text-right' : ''},[_vm._v(_vm._s(_vm.$t("DATE_OF_GENERATION")))])])])],1),_vm._v(" "),_c('div',{staticClass:"col-12 mb-3"},[_c('b-button',{directives:[{name:"b-toggle",rawName:"v-b-toggle.accordion-38",modifiers:{"accordion-38":true}}],staticClass:"d-flex text-capitalize btn_acc_new justify-content-between align-items-center",attrs:{"block":"","variant":"info"}},[_vm._v("\n          "+_vm._s(_vm.$t("HOW_MANY_TIMES"))+" ?\n          "),_c('img',{staticClass:"acc_img_new",attrs:{"src":__webpack_require__(1074)}})]),_vm._v(" "),_c('b-collapse',{attrs:{"id":"accordion-38","visible":"","accordion":"my-accordion-new","role":"tabpanel"}},[_c('div',{staticClass:"mt-2"},[_c('p',{class:_vm.isRTL ? 'text-right' : ''},[_vm._v(_vm._s(_vm.$t("BASED_ON_COUPONS")))])])])],1)]),_vm._v(" "),_c('div',{staticClass:"p-1",attrs:{"header-tag":"header","role":"tab"}},[_c('b-button',{directives:[{name:"b-toggle",rawName:"v-b-toggle.accordion-8",modifiers:{"accordion-8":true}}],staticClass:"d-flex text-capitalize btn_acc justify-content-between align-items-center mb-2",attrs:{"block":"","variant":"info"}},[_vm._v("\n                "+_vm._s(_vm.$t("TROBLESHOOTING"))+"\n       "),_c('img',{staticClass:"acc_img",attrs:{"src":__webpack_require__(1075)}})])],1),_vm._v(" "),_c('b-collapse',{staticClass:"mt-3",attrs:{"id":"accordion-8","visible":"","accordion":"my-accordion","role":"tabpanel"}},[_c('div',{staticClass:"col-12 mb-3"},[_c('b-button',{directives:[{name:"b-toggle",rawName:"v-b-toggle.accordion-39",modifiers:{"accordion-39":true}}],staticClass:"d-flex text-capitalize btn_acc_new justify-content-between align-items-center",attrs:{"block":"","variant":"info"}},[_vm._v("\n              "+_vm._s(_vm.$t("ADVANCE_BOOKING"))+" ?\n              "),_c('img',{staticClass:"acc_img_new",attrs:{"src":__webpack_require__(1074)}})]),_vm._v(" "),_c('b-collapse',{attrs:{"id":"accordion-39","visible":"","accordion":"my-accordion-new","role":"tabpanel"}},[_c('div',{staticClass:"mt-2"},[_c('p',{class:_vm.isRTL ? 'text-right' : ''},[_vm._v(_vm._s(_vm.$t("FACILITY_IS")))])])])],1),_vm._v(" "),_c('div',{staticClass:"col-12 mb-3"},[_c('b-button',{directives:[{name:"b-toggle",rawName:"v-b-toggle.accordion-40",modifiers:{"accordion-40":true}}],staticClass:"d-flex text-capitalize btn_acc_new justify-content-between align-items-center",attrs:{"block":"","variant":"info"}},[_vm._v(_vm._s(_vm.$t("BOOKING_NOT_COMPLETED"))+" ?\n          "),_c('img',{staticClass:"acc_img_new",attrs:{"src":__webpack_require__(1074)}})]),_vm._v(" "),_c('b-collapse',{attrs:{"id":"accordion-40","visible":"","accordion":"my-accordion-new","role":"tabpanel"}},[_c('div',{staticClass:"mt-2"},[_c('p',{class:_vm.isRTL ? 'text-right' : ''},[_vm._v(_vm._s(_vm.$t("TIMED_OUT")))])])])],1)])],1)])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-12 d-flex justify-content-center"},[_c('h3',{staticClass:"static_title"},[_vm._v("Faq"),_c('span',{staticClass:"small_s"},[_vm._v("s")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ })

});


// WEBPACK FOOTER //
// static/js/19.4585a1c46d6b6166ac92.js